import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { DatePicker, Table, Tooltip, Select } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { loadDashboardData } from "../../redux/rtk/features/dashboard/dashboardSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";

function CustomTable({ list, dashboardStatus }) {
    
    const [columnsToShow, setColumnsToShow] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filterStatus, setFilterStatus] = useState("All");
    const { loading } = useSelector((state) => state.users);

    const columns = [
        {
            title: "User Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (text) => {
                if (text === "Present") {
                    return (
                        <Tooltip title="Present">
                            <CheckCircleOutlined style={{ color: "green" }} />
                        </Tooltip>
                    );
                } else if (text === "On Leave") {
                    return (
                        <Tooltip title="On Leave">
                            <ExclamationCircleOutlined style={{ color: "orange" }} />
                        </Tooltip>
                    );
                } else if (text === "Absent") {
                    return (
                        <Tooltip title="Absent">
                            <CloseCircleOutlined style={{ color: "red" }} />
                        </Tooltip>
                    );
                }
                return null;
            },
        },
    ];

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    useEffect(()=>{
        setFilterStatus(dashboardStatus)

    }, [dashboardStatus])

    useEffect(() => {
        if (list) {
            const formattedData = formatData(list);
            if (filterStatus === "All") {
                setFilteredData(formattedData);
            } else {
                setFilteredData(formattedData.filter(user => user.status === filterStatus));
            }
        }
    }, [list, filterStatus]);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    const formatData = (data = {}) => {
        const formattedData = [];
        (data.todayPresentUsers || []).forEach((user) => {
            formattedData.push({ status: "Present", name: user });
        });
        (data.todayOnLeaveUsers || []).forEach((user) => {
            formattedData.push({ status: "On Leave", name: user });
        });
        (data.todayAbsentUsers || []).forEach((user) => {
            formattedData.push({ status: "Absent", name: user });
        });
        return formattedData;
    };

    return (
        <div className='ant-card p-4 rounded mt-5'>
            <div className='flex my-2 justify-between'>
                <div className='w-50'>
                    <h4 className='text-2xl mb-2'>Attendance List</h4>
                </div>
                <Select
                    defaultValue={dashboardStatus}
                    style={{ width: 150 }}
                    onChange={(value) => setFilterStatus(value)}
                >
                    <Select.Option value="All">All</Select.Option>
                    <Select.Option value="Present">Present</Select.Option>
                    <Select.Option value="On Leave">On Leave</Select.Option>
                    <Select.Option value="Absent">Absent</Select.Option>
                </Select>
            </div>
            {list && (
                <div style={{ marginBottom: "30px" }}>
                    <ColVisibilityDropdown
                        options={columns}
                        columns={columns}
                        columnsToShowHandler={columnsToShowHandler}
                    />
                </div>
            )}
            <Table
                scroll={{ x: true }}
                loading={loading}
                pagination={{
                    defaultPageSize: 20,
                }}
                columns={columnsToShow}
                dataSource={filteredData}
            />
        </div>
    );
}

const GetTotalAttendance = () => {
    
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const list = useSelector((state) => state.dashboard.list);
    
    const startdate = queryParams.get("startdate") || dayjs().format("YYYY-MM-DD");
    const enddate = queryParams.get("enddate") || startdate;
    const dashboardStatus1 = queryParams.get("dashboardStatus") || "All";
    // console.log("dashboardStatus",dashboardStatus);

    
    
    const [selectedDate, setSelectedDate] = useState(
        queryParams.get("startdate") ? dayjs(queryParams.get("startdate")) : dayjs()
    );


    useEffect(() => {
        dispatch(loadDashboardData({ startdate, enddate }));
    }, [dispatch, startdate, enddate]);

    const onDateChange = (date) => {
        if (date) {
            setSelectedDate(date);
            const formattedDate = date.format("YYYY-MM-DD");
            navigate(`?startdate=${formattedDate}&enddate=${formattedDate}`);
        }
    };

    return (
        <UserPrivateComponent permission={"readAll-user"}>
            <div className='card card-custom'>
                <div className='card-body'>
                    <div className="flex items-center mb-4">
                        <DatePicker
                            value={selectedDate}
                            onChange={onDateChange}
                            format="YYYY-MM-DD"
                        />
                    </div>
                    <CustomTable list={list} dashboardStatus={dashboardStatus1} />
                </div>
            </div>
        </UserPrivateComponent>
    );
};

export default GetTotalAttendance;


// import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
// import { DatePicker, Table, Tooltip } from "antd";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import dayjs from "dayjs";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { loadDashboardData } from "../../redux/rtk/features/dashboard/dashboardSlice";
// import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
// import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";

// function CustomTable({ list }) {
//     const [columnsToShow, setColumnsToShow] = useState([]);
//     const { loading } = useSelector((state) => state.users);

//     const columns = [
//         {
//             title: "User Name",
//             dataIndex: "name",
//             key: "name",
//         },
//         {
//             title: "Present",
//             dataIndex: "status",
//             key: "status",
//             render: (text) => {
//                 if (text === "Present") {
//                     return (
//                         <Tooltip title="Present">
//                             <CheckCircleOutlined style={{ color: "green" }} />
//                         </Tooltip>
//                     );
//                 } else if (text === "On Leave") {
//                     return (
//                         <Tooltip title="On Leave">
//                             <ExclamationCircleOutlined style={{ color: "orange" }} />
//                         </Tooltip>
//                     );
//                 } else if (text === "Absent") {
//                     return (
//                         <Tooltip title="Absent">
//                             <CloseCircleOutlined style={{ color: "red" }} />
//                         </Tooltip>
//                     );
//                 }
//                 return null;
//             },
//         },
//     ];

//     useEffect(() => {
//         setColumnsToShow(columns);
//     }, []);

//     const columnsToShowHandler = (val) => {
//         setColumnsToShow(val);
//     };

//     const formatData = (data = {}) => {
//         const formattedData = [];

//         (data.todayPresentUsers || []).forEach((user) => {
//             formattedData.push({ status: "Present", name: user });
//         });

//         (data.todayOnLeaveUsers || []).forEach((user) => {
//             formattedData.push({ status: "On Leave", name: user });
//         });

//         (data.todayAbsentUsers || []).forEach((user) => {
//             formattedData.push({ status: "Absent", name: user });
//         });

//         return formattedData;
//     };

//     return (
//         <div className='ant-card p-4 rounded mt-5'>
//             <div className='flex my-2 justify-between'>
//                 <div className='w-50'>
//                     <h4 className='text-2xl mb-2'>Attendance List</h4>
//                 </div>
//             </div>
//             {list && (
//                 <div style={{ marginBottom: "30px" }}>
//                     <ColVisibilityDropdown
//                         options={columns}
//                         columns={columns}
//                         columnsToShowHandler={columnsToShowHandler}
//                     />
//                 </div>
//             )}
//             <Table
//                 scroll={{ x: true }}
//                 loading={loading}
//                 pagination={{
//                     defaultPageSize: 20,
//                 }}
//                 columns={columnsToShow}
//                 dataSource={list ? formatData(list) : []}
//             />
//         </div>
//     );
// }

// const GetTotalAttendance = () => {
//     const dispatch = useDispatch();
//     const location = useLocation();
//     const navigate = useNavigate();
//     const queryParams = new URLSearchParams(location.search);
//     const list = useSelector((state) => state.dashboard.list);
    
//     // Get startdate from URL params or default to today
//     const startdate = queryParams.get("startdate") || dayjs().format("YYYY-MM-DD");
//     const enddate = queryParams.get("enddate") || startdate;
    
//     // Set date picker value based on startdate from URL
//     const [selectedDate, setSelectedDate] = useState(
//         queryParams.get("startdate") ? dayjs(queryParams.get("startdate")) : dayjs()
//     );

//     useEffect(() => {
//         // Load dashboard data with the date parameters from URL
//         dispatch(loadDashboardData({ startdate, enddate }));
//     }, [dispatch, startdate, enddate]);

//     // Update when date picker changes
//     const onDateChange = (date) => {
//         if (date) {
//             setSelectedDate(date);
//             const formattedDate = date.format("YYYY-MM-DD");
            
//             // Update URL with new startdate parameter
//             navigate(`?startdate=${formattedDate}&enddate=${formattedDate}`);
//         }
//     };

//     return (
//         <UserPrivateComponent permission={"readAll-user"}>
//             <div className='card card-custom'>
//                 <div className='card-body'>
//                     <div className="flex items-center mb-4">
//                         <DatePicker
//                             value={selectedDate}
//                             onChange={onDateChange}
//                             format="YYYY-MM-DD"
//                         />
//                         {/* <div className="ml-4 text-gray-600">
//                             {queryParams.get("startdate") ? 
//                                 `Filtering data by date: ${dayjs(startdate).format("DD MMM YYYY")}` : 
//                                 "Showing today's attendance"
//                             }
//                         </div> */}
//                     </div>
//                     <CustomTable list={list} />
//                 </div>
//             </div>
//         </UserPrivateComponent>
//     );
// };

// export default GetTotalAttendance;